import { IconProps } from "@/components/Icons/index";

export const ChevronDownIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 13.17L7.05 8.21995L5.63 9.62995L11.99 15.99L18.35 9.61995L16.93 8.19995L11.98 13.14L12 13.17Z"
        fill="currentColor"
      />
    </svg>
  );
};
